import * as latex from 'katex';
import markdownit from 'markdown-it';
import * as React from "react";
import { TextAreaOptions } from "../main";
import { IOWidget, mk_widget, option } from "../widget";


const mathBlock = (code:string) => {
  let tex = ''
  code.split(/(?:\n\s*){2,}/).forEach((line) => { // consecutive new lines means a new formula
    try {
      tex += latex.renderToString(line.trim(), { displayMode: true })
    } catch (err) {
      tex += `<pre>${err}</pre>`
    }
  })
  return `<div>${tex}</div>`
}
const variable = function (state:any) {
  var variableStart = state.src.indexOf("$", state.pos);
  var variableEnd = state.src.indexOf("$", variableStart + 1);

  if (variableStart !== -1 && variableEnd !== -1) {
    const content = state.src.slice(variableStart, variableEnd + 1);

    if (!content.match(/\r\n|\r|\n/g)) {
      var token = state.push("markdown-it-variable", "span", 0);
      token.attrs = [
        ["class", "test-variable test-variable-with-tooltip"],
        ["title", "This represents a test variable and will be replaced during testing if configured"]];
      token.content = content;
      token.markup = content;
    } else {
      state.pending += state.src.slice(state.pos, variableEnd + 1);
    }
    state.pos = variableEnd + 1;
    return true;
  }

  state.pending += state.src.slice(state.pos, state.maxPos);
  state.pos = state.maxPos;
  return true;
};


const markdownItLatex = (md:any) => {
  md.inline.ruler.push("markdown-it-variable", variable, { alt: [] });

  md.renderer.rules["markdown-it-variable"] = function (tokens:any, idx:any, _opts:any, _env:any, self:any) {
      const token = tokens[idx];
      let code = tokens[idx].content


      if (code.startsWith('$') && code.endsWith('$')) { // inline math
        code = code.substr(1, code.length - 2)
        try {
          return latex.renderToString(code)
        } catch (err) {

          return `<code>${err}</code>`
        }
      }
      return temp1(tokens, idx, _opts, _env, self)
      // return '<span' + self.renderAttrs(token) + '>' + tokens[idx].content + '</span>';
  };

  // inline math
  const temp1 = md.renderer.rules.code_inline.bind(md.renderer.rules)
  md.renderer.rules.code_inline = (tokens:any, idx:any, options:any, env:any, slf:any) => {
    let code = tokens[idx].content


    if (code.startsWith('$') && code.endsWith('$')) { // inline math
      code = code.substr(1, code.length - 2)
      try {
        return latex.renderToString(code)
      } catch (err) {
        return `<code>${err}</code>`
      }
    }
    return temp1(tokens, idx, options, env, slf)
  }

  // fenced math block
  const temp2 = md.renderer.rules.fence.bind(md.renderer.rules)
  md.renderer.rules.fence = (tokens:any, idx:any, options:any, env:any, slf:any) => {
    let token = tokens[idx]
    let code = token.content.trim()
    if (token.info === 'math' || token.info === 'katex') { // math
      return mathBlock(code)
    }
    // if (/^ascii-?math/i.test(token.info)) {
    //   code = code.split(/(?:\n\s*){2,}/).map((item) => { return asciimath2latex(item) }).join('\n\n')
    //   return mathBlock(code)
    // }
    return temp2(tokens, idx, options, env, slf)
  }
}


export type MarkupRenderer = (content: string) => MarkupRendererResponse
export type MarkupRendererResponse = { errors: Array<string>, element: JSX.Element }

export type MarkupViewer = (_: MarkupViewerProps) => JSX.Element
export type MarkupViewerProps = {
  options?:TextAreaOptions,
  content: MarkupContent,
  save: (_: MarkupContent) => void,
  mode: "edit" | "view" | "presentation" }

export type MarkupKind = "LaTeX" | "Markdown"
export interface MarkupContent { kind: MarkupKind, text: string }

export const mk_MarkupContent = (kind: MarkupKind): MarkupContent => ({ kind: kind, text: "" })
// let serialise = (content: MarkupContent) => JSON.stringify(content)
// let deserialise = (json: string): MarkupContent => {
//   try {
//     let content = JSON.parse(json) as MarkupContent
//     if (content == null) throw new Error("Content is not of type MarkupContent")
//     return content
//   } catch (e) {
//     console.log(e)
//     return newMarkUpContent("LaTeX")
//   }
// }

const katexRenderer: MarkupRenderer = (content: string) => {
  try {
    let html = latex.renderToString(content, { displayMode: false })
    let element = <div dangerouslySetInnerHTML={{ __html: html }} />
    return { errors: [], element: element }
  } catch (e) {
    return { errors: [e.message], element: <div /> }
  }
}

const markdownRenderer: MarkupRenderer = (content: string) => {
  let mdi = new markdownit()
  mdi.use(markdownItLatex)

  let html = mdi.render(content)

  let element = <div dangerouslySetInnerHTML={{ __html: html }} />
  return { errors: [], element: element }
}

const kindToRenderer = (kind: MarkupKind) => {
  switch (kind) {
    case "LaTeX":
      return katexRenderer
    case "Markdown":
      return markdownRenderer
  }
}

/* deadcode */
/* const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1) */

const markupViewer: MarkupViewer = (props: MarkupViewerProps) => {

  let renderer = kindToRenderer(props.content.kind)
  let rendererResponse = renderer(props.content.text)

  let editArea = (content: MarkupContent, setContent: (_: MarkupContent) => void, hasError: boolean, options?:TextAreaOptions, ) =>
    <textarea rows={option("rows", options)} cols={option("columns", options)} value={content.text} onChange={(e) => setContent({ ...content, text: e.currentTarget.value })} className={hasError ? 'has-error' : ''} />

  // let markUpLanguageSelect = (languages: MarkupKind[]) =>
  //   <select
  //     defaultValue={props.content.kind}
  //     onChange={e => { props.save({...props.content, kind: e.currentTarget.value as MarkupKind})}}>
  //     { languages.map( kind => <option key={`markup-option-${kind}`} value={kind}>{kind}</option> ) }
  //   </select>
  let className = props.content.kind.toLowerCase()

  if (props.mode == "view" || props.mode == "edit") {
    return (
        props.mode == "edit"
        ? <div id={option("id", props.options)} className={option("className", props.options)}>
            {editArea(props.content, props.save, rendererResponse.errors.length > 0, props.options)}
            {rendererResponse.element}
            {rendererResponse.errors.map(e => <span>{e}</span>)}
          </div>

        : <div id={option("id", props.options)} className={option("className", props.options)}>
            {rendererResponse.element}
          </div>
    )
  }
  else /* props.mode == "presentation" */ {
    return rendererResponse.element
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const markup = (options?:TextAreaOptions) : IOWidget<MarkupContent,MarkupContent> =>
{
    return (content:MarkupContent) => mk_widget({
      run:(on_done:(output:MarkupContent) => void) =>
        markupViewer({
          content: content,
          save: (new_content: MarkupContent) => on_done(new_content),
          mode: option("readonly", options) ? "view" : "edit"
        })
      })
}

